<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <img src="../../assets/images/activity/activity2023114/title1-1.png" alt="" class="title">
      <div class="img imgGif">
        <img src="../../assets/images/activity/activity2023114/lmsj.gif" alt="">
      </div>
      <img src="../../assets/images/activity/activity2023114/title1-2.png" alt="" class="title">
      <div class="info">
        <p>大智慧「365」用户在软件内打开任意个股K线，搜索“六脉神剑”或首字母“LMSJ”回车确认后即可在幅图指标查看“六脉神剑指标信号”</p>
        <div class="search">
          <span>个股K线 </span>
          <img src="../../assets/images/activity/activity2023114/arrow.png" alt="" >
          <span>搜索“六脉神剑”或“LMSJ”</span>
          <img src="../../assets/images/activity/activity2023114/arrow.png" alt="" >
          <span>六脉神剑</span>
        </div>
      </div>
      <div class="img noShadow">
        <img src="../../assets/images/activity/activity2023114/img1-2.jpg" alt="">
        <div class="buy-bar"  @click="goUrl(116)">
          <img src="../../assets/images/activity/activity2023114/buy-btn.png" alt="">
        </div>
      </div>
      <img src="../../assets/images/activity/activity2023114/title1-3.png" alt="" class="title mt300">
      <img src="../../assets/images/activity/activity2023114/info1.jpg" alt="">
      <div class="img noShadow">
        <img src="../../assets/images/activity/activity2023114/img1-3.jpg" alt="">
      </div>
      <div class="line">
        <span></span>
        <span></span>
      </div>
      <img src="../../assets/images/activity/activity2023114/info2.jpg" alt="">
      <div class="img">
        <img src="../../assets/images/activity/activity2023114/img1-4.jpg" alt="">
      </div>
      <img src="../../assets/images/activity/activity2023114/info4.png" alt="" class="info4">
      <img src="../../assets/images/activity/activity2023114/title1-4.png" alt="" class="title">
      <img src="../../assets/images/activity/activity2023114/info3.jpg" alt="">
      <div class="img">
        <img src="../../assets/images/activity/activity2023114/img1-5.jpg" alt="">
      </div>
      <div class="info5">
        <p>大智慧「365」更多功能</p>
        <p>不断更新迭代中，敬请期待...</p>
      </div>
    </div>
    <div class="footer-mod">
      <div class="btm-buy" @click="goUrl(116)">
        <img src="../../assets/images/activity/activity2023114/buy-btn2.png" alt="">
      </div>
      <p>广告 风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；</p>
      <p>所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。</p>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {

  },
  methods: {
    goUrl (key, month=24) {
      let routerDate;
      if (this.token && key !== 4024) {
        routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      } else {
        routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      }
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background: url(../../assets/images/activity/activity2023114/bg.jpg) no-repeat center 100px #273250;
  .auto{
    width: 1072px;
    margin: 0 auto;
    padding-top: 787px;
    padding-bottom: 100px;
  }
  .title{
    margin: 0 auto 50px;
    display: block;
    &.mt300{
      margin-top: 300px;
    }
  }
  .img{
    // width: 1072px;
    padding: 30px;
    background: #fff;
    margin: 0 auto;
    position: relative;
    &.noShadow{
      &:after{
        display: none;
      }
    }
    &:after{
      content: '';
      display: block;
      position: absolute;
      left: -5px;
      top: 100%;
      background: url(../../assets/images/activity/activity2023114/img-bg.png) no-repeat;
      width: 1088px;
      height: 43px;
    }
    img{
      display: block;
      width: 100%;
      border: 5px solid #ffd200;
      border-radius: 5px;
    }
  }
  .imgGif{
    margin-bottom: 60px;
    img{
      border: none;
      border-radius: 0;
    }
  }
  .info{
    background: #465477;
    padding: 30px 35px;
    p{
      font-size: 28px;
      color: #c8e4f0;
      line-height: 40px;
      letter-spacing: 1px;
    }
    .search{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      span{
        padding:13px;
        background: #b18c34;
        color: #fff;
        font-size: 28px;
        line-height: 1;
      }
      img{
        flex: none;
        height: 20px;
        margin: 0 10px;
      }
    }
  }
  .buy-bar{
    position: absolute;
    left: -43px;
    width: 1153px;
    height: 278px;
    background: url(../../assets/images/activity/activity2023114/bg2.png) no-repeat;
    top: 96%;
    cursor: pointer;
    img{
      width: 668px;
      border-radius: 0;
      border: none;
      position: absolute;
      bottom: 35px;
      left: 340px;
      // animation: bigger 1.5s linear infinite;
      animation:zoom 2s linear infinite;
      cursor: pointer;
    }
  }
  .line{
    display: flex;
    height: 78px;
    width: 100%;
    padding: 0 163px;
    justify-content: space-between;
    span{
      width: 11px;
      height: 100%;
      background-image: linear-gradient(to bottom, #fafafc,#4d5a7c);
    }
  }
  .info4{
    margin: 116px auto 94px;
  }
  .info5{
    color: #fff;
    font-size: 44px;
    margin: 35px 0 55px;
    text-align: center;
    text-shadow: 0 3px #121e3e;
  }
  .footer-mod{
    background: #222729;
    padding: 140px 0 55px;
    color: rgba($color: #fff, $alpha: 0.2);
    font-size: 12px;
    position: relative;
    p{
      text-align: center;
      margin-bottom: 5px;
    }
    .btm-buy{
      width: 951px;
      height: 166px;
      background: url(../../assets/images/activity/activity2023114/btm-bg.png) no-repeat;
      position: absolute;
      left: 50%;
      margin-left: -475px;
      margin-top: -227px;
      padding-top: 85px;
      font-size: 40px;
      color: #fff;
      padding-left: 190px;
      cursor: pointer;
      img{
        // animation: bigger 1.5s linear infinite;
        animation:zoom 2s linear infinite;
      }
    }
  }
}
 @keyframes bigger {
  0%{
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  50%{
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100%{
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
}
@keyframes zoom{
  0%{transform:scale(1)}
  10%{transform:scale(0.85)}
  20%{transform:scale(1.05)}
  30%{transform:scale(0.9)}
  40%{transform:scale(1)}
  100%{transform:scale(1)}
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activity2023114.vue